import { MarketGrade } from '@hcs/types';

import { CerberusStatsMsa, CerberusStatsZip } from '../types';
import {
  msaDetailsQueryToCerberusStatsMsa,
  zipDetailsQueryToCerberusStatsZip,
} from '../utils';

export const MOCK_CERBERUS_STATS_ZIP: CerberusStatsZip | null | undefined =
  zipDetailsQueryToCerberusStatsZip({
    lookupZipDetails: {
      zipcode: '94107',
      msa: '41860',
      preferredName: 'San Francisco, CA',
      listingStats: {
        latestStats: {
          daysOnMarketMedian: 44,
          daysOnMarketMedianMovingAvg: 44,
          daysOnMarketNotContractMedian: 2,
          daysOnMarketNotContractMedianMovingAvg: 2,
          daysToCloseMedian: 19,
          daysToCloseMedianMovingAvg: 19,
          daysToContractMedian: 19,
          daysToContractMedianMovingAvg: 0,
          daysToFirstPriceDropMedian: null,
          daysToFirstPriceDropMedianMovingAvg: null,
          eventDate: null,
          listingsClosedCount: 1,
          listingsClosedCountMovingAvg: 0,
          listingsNewCount: 1,
          listingsNewCountMovingAvg: 0,
          listingsOnMarketCount: 2,
          listingsOnMarketCountMovingAvg: 2,
          listingsPriceChangeCount: 0,
          listingsPriceChangeCountMovingAvg: 0,
          listingsPriceDropCount: 0,
          listingsPriceDropCountMovingAvg: 0,
          listingsPriceDropPercent: 0,
          listingsPriceDropPercentMovingAvg: 0,
          listingsRemovedCount: null,
          listingsRemovedCountMovingAvg: null,
          listingsRemovedPercent: null,
          listingsRemovedPercentMovingAvg: null,
          listingsUnderContractCount: 0,
          listingsUnderContractCountMovingAvg: 0,
          listingsUnderContractPercent: 50,
          listingsUnderContractPercentMovingAvg: 82.35,
          monthsOfSupplyMedian: 0.8,
          monthsOfSupplyMedianMovingAvg: 0.8,
          priceClosedMedian: 1560000,
          priceClosedMedianMovingAvg: 1560000,
          priceNewListMedian: 1495000,
          priceNewListMedianMovingAvg: 1396250,
          priceOnMarketMedian: 1495000,
          priceOnMarketMedianMovingAvg: 1367206,
          pricePerSqftClosedMedian: 1028.35,
          pricePerSqftClosedMedianMovingAvg: 1028.35,
          pricePerSqftNewListMedian: 1150,
          pricePerSqftNewListMedianMovingAvg: 1043.78,
          pricePerSqftOnMarketMedian: 1150,
          pricePerSqftOnMarketMedianMovingAvg: 875.07,
          saleToListPriceMedian: null,
          saleToListPriceMedianMovingAvg: null,
          saleToListPriceOriginalMedian: null,
          saleToListPriceOriginalMedianMovingAvg: null,
        },
      },
      hpi: {
        forecastCalcs: {
          risk1YearLoss: 0.373901,
          return: {
            return1YearForecast: 0.0062,
          },
        },
        timeSeriesCurrent: null,
      },
      hcri: {
        grossYieldMedian: 0.0614,
      },
      rpi: {
        forecastCalcs: [
          {
            risk1YearLoss: 0.0534,
            return1Year: 0.0624,
          },
        ],
        timeSeriesCurrent: null,
      },
      marketQuality: {
        grade: MarketGrade.C,
      },
    },
  });

export const MOCK_CERBERUS_STATS_MSA: CerberusStatsMsa | null | undefined =
  msaDetailsQueryToCerberusStatsMsa({
    lookupMsaDetails: {
      msa: '99999',
      name: 'Test MSA, QA',
      zipCount: 3,
      listingStats: {
        latestStats: {
          daysOnMarketMedian: 38,
          daysOnMarketMedianMovingAvg: 37,
          daysOnMarketNotContractMedian: 36,
          daysOnMarketNotContractMedianMovingAvg: 32,
          daysToCloseMedian: 55,
          daysToCloseMedianMovingAvg: 54,
          daysToContractMedian: 38,
          daysToContractMedianMovingAvg: 38,
          daysToFirstPriceDropMedian: 34,
          daysToFirstPriceDropMedianMovingAvg: 31,
          eventDate: null,
          listingsClosedCount: 60,
          listingsClosedCountMovingAvg: 73,
          listingsNewCount: 80,
          listingsNewCountMovingAvg: 103,
          listingsOnMarketCount: 1175,
          listingsOnMarketCountMovingAvg: 1158,
          listingsPriceChangeCount: 74,
          listingsPriceChangeCountMovingAvg: 70,
          listingsPriceDropCount: 70,
          listingsPriceDropCountMovingAvg: 63,
          listingsPriceDropPercent: 5.96,
          listingsPriceDropPercentMovingAvg: 5.44,
          listingsRemovedCount: 9,
          listingsRemovedCountMovingAvg: 11,
          listingsRemovedPercent: 0,
          listingsRemovedPercentMovingAvg: 0,
          listingsUnderContractCount: 75,
          listingsUnderContractCountMovingAvg: 74,
          listingsUnderContractPercent: 32.77,
          listingsUnderContractPercentMovingAvg: 33.55,
          monthsOfSupplyMedian: 4.43,
          monthsOfSupplyMedianMovingAvg: 4.37,
          priceClosedMedian: 700000,
          priceClosedMedianMovingAvg: 707728,
          priceNewListMedian: 809950,
          priceNewListMedianMovingAvg: 800379,
          priceOnMarketMedian: 775000,
          priceOnMarketMedianMovingAvg: 766502,
          pricePerSqftClosedMedian: 387.11,
          pricePerSqftClosedMedianMovingAvg: 374.21,
          pricePerSqftNewListMedian: 399.07,
          pricePerSqftNewListMedianMovingAvg: 411.14,
          pricePerSqftOnMarketMedian: 394.96,
          pricePerSqftOnMarketMedianMovingAvg: 392.4,
          saleToListPriceMedian: 99.38,
          saleToListPriceMedianMovingAvg: 99.73,
          saleToListPriceOriginalMedian: 98.14,
          saleToListPriceOriginalMedianMovingAvg: 98.73,
        },
      },
      rentalListingStats: {
        latestStats: {
          daysOnMarketMedian: 30,
          daysOnMarketMedianMovingAvg: 32,
          daysOnMarketNotContractMedian: null,
          daysOnMarketNotContractMedianMovingAvg: null,
          daysToCloseMedian: null,
          daysToCloseMedianMovingAvg: null,
          daysToContractMedian: null,
          daysToContractMedianMovingAvg: null,
          daysToFirstPriceDropMedian: null,
          daysToFirstPriceDropMedianMovingAvg: null,
          eventDate: null,
          listingsClosedCount: null,
          listingsClosedCountMovingAvg: null,
          listingsNewCount: 1027,
          listingsNewCountMovingAvg: 975,
          listingsOnMarketCount: 6949,
          listingsOnMarketCountMovingAvg: 6796,
          listingsPriceChangeCount: null,
          listingsPriceChangeCountMovingAvg: null,
          listingsPriceDropCount: null,
          listingsPriceDropCountMovingAvg: null,
          listingsPriceDropPercent: null,
          listingsPriceDropPercentMovingAvg: null,
          listingsRemovedCount: 9,
          listingsRemovedCountMovingAvg: 13,
          listingsRemovedPercent: 0,
          listingsRemovedPercentMovingAvg: 0,
          listingsUnderContractCount: null,
          listingsUnderContractCountMovingAvg: null,
          listingsUnderContractPercent: null,
          listingsUnderContractPercentMovingAvg: null,
          monthsOfSupplyMedian: 2.77,
          monthsOfSupplyMedianMovingAvg: 2.71,
          priceClosedMedian: null,
          priceClosedMedianMovingAvg: null,
          priceNewListMedian: 2500,
          priceNewListMedianMovingAvg: 2499,
          priceOnMarketMedian: 2500,
          priceOnMarketMedianMovingAvg: 2495,
          pricePerSqftClosedMedian: null,
          pricePerSqftClosedMedianMovingAvg: null,
          pricePerSqftNewListMedian: 1.32,
          pricePerSqftNewListMedianMovingAvg: 1.32,
          pricePerSqftOnMarketMedian: 1.3,
          pricePerSqftOnMarketMedianMovingAvg: 1.3,
          saleToListPriceMedian: null,
          saleToListPriceMedianMovingAvg: null,
          saleToListPriceOriginalMedian: null,
          saleToListPriceOriginalMedianMovingAvg: null,
        },
      },
      hpi: {
        forecastCalcs: {
          risk1YearLoss: 0.441481,
          return: {
            return1YearForecast: 0.023,
          },
        },
        timeSeriesCurrent: null,
      },
      hcri: {
        grossYieldMedian: 0.073,
      },
      rpi: {
        forecastCalcs: [
          {
            risk1YearLoss: 0.8903,
            return1Year: -0.0369,
          },
        ],
        timeSeriesCurrent: null,
      },
      populationStats: {
        population: {
          month: null,
          population1YearAgo: 206483,
          population1YearChange: 2030,
          population1YearRatio: 1.0098,
        },
      },
    },
  });
